var PostEventType;
(function (PostEventType) {
  PostEventType["discord"] = "discord";
  PostEventType["meets"] = "meets";
  PostEventType["youtube"] = "youtube";
  PostEventType["zoom"] = "zoom";
  PostEventType["other"] = "other";
})(PostEventType || (PostEventType = {}));

export { PostEventType };
